<template>
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加工作分类')">添加</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteGroup">批量删除</el-button>
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
    </div>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        style="width: max-content"
        :data="tableData"
        :stripe="true"
        :border="true"
        size="mini"
        tooltip-effect="dark"
        :max-height="tableH - 47"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column prop="name" label="工作分类" width="120" />
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isPublished" style="color: #67c23a">发布中</span>
            <span v-else style="color: #909399">已下架</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.orders === null">-</span>
            <span v-else style="color: #909399">{{ scope.row.orders }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="160">
          <template slot-scope="scope">
            <div style="display:flex;justify-content:center">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="openDialog('编辑工作分类', scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" style="margin-left: 10px" @click="handleDeleteCategory(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 添加 编辑对话框 -->
    <el-dialog :close-on-click-modal="false" width="500px" :title="dialogTitle" :visible.sync="showDialog" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" style="margin: 20px 0" :rules="rules" :model="form" label-width="80px">
        <el-form-item prop="name" label-width="100px" label="分类名称：">
          <el-input v-model="form.name" resize="none" />
        </el-form-item>
        <el-form-item prop="isPublished" label-width="100px" label="状态：">
          <el-radio-group v-model="form.isPublished">
            <el-radio :label="1">发布中</el-radio>
            <el-radio :label="0">已下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="orders" label-width="100px" label="排序：">
          <el-input v-model="form.orders" type="number" resize="none" style="max-width: 80px" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit(dialogTitle === '添加企业')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { deepClone } from '@/utils'
import pagination from '@/mixins/pagination'

export default {
  mixins: [pagination],
  data() {
    const self = this
    return {
      tableData: [],
      loading: true,
      showDialog: false,
      dialogTitle: '',
      form: {
        isPublished: null,
        name: '',
        orders: null
      },
      rules: {
        isPublished: [{ required: true, message: '请选择状态', trigger: 'change' }],
        name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        orders: [{ required: true, message: '请输入数字排序', trigger: 'blur' }]
      },
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      total: 0,
      ids: [],
      tableH: 0
    }
  },

  mounted() {
    this.getTableList()
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    getTableList() {
      this.loading = true
      return this.$api.operation
        .reqCategoryList(this.page)
        .then((res) => {
          this.tableData = res.records
          this.total = res.total
          this.loading = false
        })
        .catch(() => {})
    },
    openDialog(title, row) {
      this.dialogTitle = title
      this.showDialog = true
      if (!row) return
      this.$nextTick(() => {
        this.form.isPublished = row.isPublished ? 1 : 0
        this.form.id = row.id
        this.form.name = row.name
        this.form.orders = row.orders
      })
    },
    handleSubmit(isAdd) {
      if (!this.validateForm()) return
      const data = Object.assign({}, this.form)
      data.isPublished = Boolean(data.isPublished)
      if (this.dialogTitle === '添加工作分类') {
        this.loading = true
        this.$api.operation
          .reqAddCategory(data)
          .then((res) => {
            this.$message.success(res)
            this.getTableList()
          })
          .catch((e) => {
            this.$message.error(e)
          })
      } else {
        this.loading = true
        this.$api.operation
          .reqUpdateCategory(data)
          .then((res) => {
            this.$message.success(res)
            this.getTableList()
          })
          .catch((e) => {
            this.$message.error(e)
          })
      }
      this.showDialog = false
      this.loading = true
    },
    verifyCompany(auth, id) {
      this.loading = true
      this.$api.company
        .reqUpdateCompanyAuth({ auth, id })
        .then((res) => {
          this.loading = false
          this.$message.success('操作成功')
        })
        .catch((e) => {
          this.getTableList()
          this.$message.error(e)
        })
    },
    deleteGroup() {
      if (!this.ids.length) return this.$message.info('当前无选中项')
      this.$confirm('此操作将永久删除选中的工作分类, 是否继续?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$api.operation
            .reqDeleteCategory({ ids: this.ids.join(',') })
            .then((res) => {
              this.$message.success('操作成功')
              this.getTableList()
            })
            .catch((e) => {
              this.$message.error(e)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleSelectionChange(e) {
      this.ids = e.map((item) => item.id)
    },
    handleDeleteCategory(row) {
      this.$confirm('此操作将永久删除该工作分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$api.operation
            .reqDeleteCategory({ ids: row.id })
            .then((res) => {
              this.$message({
                type: 'success',
                message: res
              })
              this.loading = true
              this.getTableList()
            })
            .catch((e) => {
              this.$message({
                type: 'info',
                message: e
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    },
    handleCurrentChange(e) {
      this.page.pageNumber = e
      this.getTableList()
    },
    handleSizeChange(e) {
      this.page.pageSize = e
      this.getTableList()
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Promise.all([this.getTableList()])
        .then((res) => {
          this.$message.success('刷新成功')
        })
        .catch(() => {
          this.$message.error('刷新成功')
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
